

export function Error(error) {
    // console.log(
    //     [error]
    // )
    let message = "error";
    if (error.reason) {
        message = error.reason;
    } else if (error.error?.message) {
        message = error.error.message;
    } else if (error.message) {
        message = error.message;
    }
    return message
    // const re = e.data ? e.data.data ? e.data.data.message : (e.data.message ? e.data.message : e.message) : e.message
    // return re || 'Input error'
}
